import PropTypes from 'prop-types';
import InspirationCard from './InspirationCard';

export default class MainPanel extends React.Component {
    static propTypes = {
        inspirationsData: PropTypes.array
    };
    static defaultProps = {

    };
    constructor(props) {
        super(props);
    }
    componentDidMount() {
        $('.sandals-loader').addClass('super-secret');
        this._onDragItem();
    }
    _onDragItem = () => {
        const owl = $('.owl-carousel');

        owl.owlCarousel();
        owl.on('dragged.owl.carousel', (e) => {
            const isReceptionSet = $(e.currentTarget).closest('.owl-carousel').find('.owl-stage').find('.owl-item.active').children().hasClass('reception-set');
            const stageBar = $(e.currentTarget).closest('.inspiration-card').find('.wedding-stage');
            const ceremonyOption = stageBar.find('.ceremony.option');
            const receptionOption = stageBar.find('.reception.option');

            if (isReceptionSet) {
                ceremonyOption.removeClass('active');
                receptionOption.addClass('active');
            } else {
                receptionOption.removeClass('active');
                ceremonyOption.addClass('active');
            }
        });
    };
    _setFirstInspiration = (inspirationId) => {
        const first = [];
        const other = [];

        this.props.inspirationsData.map(inspiration => {
            if(inspiration.id === inspirationId) {
                first.push(inspiration);
            } else {
                other.push(inspiration);
            }
        });
        const mergedItems = [...first, ...other];

        return mergedItems;
    };

    _renderInspirationCards = inspirationsData => inspirationsData.map((inspiration, index) => <InspirationCard key={ index } inspirationId={ inspiration.id } name={ inspiration.name } description={ inspiration.description } images= { inspiration.images }/>);

    render() {
        const sortedInspirations = this._setFirstInspiration(10);
        const cards = this._renderInspirationCards(sortedInspirations);

        return (
        <div className="txt-center container">
            {cards}
        </div>
        );
    }
}
